import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { DataResult } from "@progress/kendo-data-query";
import { Observable } from "rxjs";
import { AppConstant } from "src/app/app.constant";
import { map } from 'rxjs/operators';
import { DataToDelete } from "src/app/_metronic/core/classes/core.class";

@Injectable()
export class SchoolService{
    apiUrl: string;
    kendoDataUrl: string;

    constructor(private httpClient: HttpClient, private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl();
    }
    manageSchool(School) {
        return this.httpClient.post(`${this.apiUrl}/manageSchool`, School).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    public getAllSchool(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllSchool/`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    bulkDeleteSchool(sectionIdNameList: Array<DataToDelete> = []) {
        return this.httpClient.post(`${this.apiUrl}/bulkDeleteSchool/`, {
          DataToDelete: sectionIdNameList
        }).pipe(
          map((response: any) => {
            return response;
          }))
      }
      getSchoolById(Id : number) {
        return this.httpClient.get(`${this.apiUrl}/getSchoolById/` + Id).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    public getAllSchoolName(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllSchoolName/`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    bulkInsert(schoolData) {
        return this.httpClient.post(`${this.apiUrl}/bulkImportSchool`, schoolData).pipe(
          map((response: any) => {
            return response;
          })
        )
      }
}